<template>
  <div>

    <!-- 강의 정보 -->
    <div>
      <div class="mb-4 flex flex-wrap items-center justify-start gap-3">
        <h5><i class="dot"></i>강의 정보</h5>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>교육 대상</div>
          <div><ml-input v-model="form.교육대상"/></div>
        </div>
        <div class="writeGridLineItem">
          <div>교육 종류</div>
          <div>
            <vs-select class="w-full" autocomplete v-model="form.videoCode">
              <vs-select-item
                v-for="(item, index) in TRAINING_VIDEO_CODE_LIST"
                :key="index"
                :text="getVideoCodeText(item)"
                :value="item"
              />
            </vs-select>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>제목</div>
          <div><ml-input v-model="form.제목"/></div>
        </div>
        <div class="writeGridLineItem">
          <div>개요</div>
          <div>
            <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.개요" :options="{
              placeholder: '내용을 입력해주세요'
            }"></quill-editor>
          </div>
        </div>
      </div>
    </div>

    <!-- 동영상 업로드 -->
    <div class="mt-8">
      <div class="mb-4 flex flex-wrap items-center justify-start gap-3">
        <h5><i class="dot"></i>동영상 업로드</h5>
      </div>
      <div class="p-4 border rounded text-left">
        <div class="grid gap-2">
          <p class="flex items-center gap-2" style="font-weight: 500;">
            <img src="@/assets/icons/youtube_32x32.png" alt="YouTube" style="width: 32px;">
            YouTube URL
          </p>
          <p>URL에서 삽입을 통해 비디오 링크를 붙여넣으세요.</p>
          <p class="flex items-center gap-2">
            <ml-input class="flex-1" placeholder="URL을 입력해주세요." v-model="form.youtubeUrl"/>
            <vs-button class="py-2 px-6" color="secondary" @click="loadYoutube()">임베드</vs-button>
          </p>
          <div class="relative" :style="{paddingBottom: form.duration ? '56.25%' : '0'}">
            <div id="player" style="position: absolute; top: 0; left: 0; right: 0; bottom:0; height: 100%;"></div>
          </div>
          <p>영상길이: {{formatDuration(form.duration)}}</p>
          <p class="flex items-center gap-2">
            수강완료 가능한 진행도(%):
            <ml-input type="number" :min-value="0" :max-value="100" v-model="form.validWatchProgress"/>
            <span style="color:#7e72f2; font-weight: 600;">{{formatDuration(form.watchedSecondsForPass, 'mm분 ss초')}}</span>이상 시청 시 수강완료로 인정됩니다.
          </p>
        </div>
      </div>
    </div>

    <!-- 시험문제 등록 -->
    <div>
      <table-custom
        class="mt-4"
        :controls="true"
        :multiple="true"
        title="시험문제 등록"
        :tableData="[
          { id: 'title', title: '문제', type: 'textarea', placeholder: '', rows: 5},
          { id: 'options', title: '보기', type: 'customType', placeholder: '' },
        ]"
        :mobile="['title', 'name']"
        :use-bottom-add-button="true"
        v-model="form.questions"
      >
        <template #customType="{ id, indexTd, index, isMobile, value, trData }">
          <div class="w-full">
            <table class="w-full mb-2" style="border-top: 1px solid #cdcdcd; border-left: 1px solid #cdcdcd;">
              <colgroup>
                <col style="min-width: 50px; width: 50px;"/>
                <col style="min-width: 120px;"/>
                <col style="min-width: 70px; width: 70px;"/>
                <col style="min-width: 50px; width: 50px;"/>
              </colgroup>
              <tr>
                <td>No.</td>
                <td>항목</td>
                <td>정답여부</td>
                <td></td>
              </tr>
              <tr v-for="(option, optionIndex) in trData.options" :key="optionIndex">
                <td>{{ optionIndex + 1 }}</td>
                <td>
                  <ml-input :value="option.label" @input="(value) => onInputOptionsValue(index, optionIndex, 'label', value)"/>
                </td>
                <td>
                  <div class="flex items-center justify-center">
                    <vs-checkbox :value="option.answer" :vs-value="true" @change="($event) => onInputOptionsValue(index, optionIndex, 'answer', $event.target.checked)"/>
                  </div>
                </td>
                <td>
                  <vs-button class="py-1 px-2" color="danger" @click="deleteOptions(index, optionIndex)">X</vs-button>
                </td>
              </tr>
            </table>
            <vs-button class="p-0 w-full" style="font-size: 2rem;" color="secondary" @click="addQuestionsOptions(index)">+</vs-button>
          </div>

        </template>
      </table-custom>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>출제될 문제 수</div>
          <div class="flex items-center" >
            <ml-input class="ml-2 mr-1" style="width: 50px;" type="number" v-model="form.randomQuestionCount" :min-value="0" :max-value="form.questions.length"/>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>합격여부</div>
          <div class="flex items-center" >
            <span class="mr-1" style="color: #7e72f2; font-weight: 500;">{{ form.randomQuestionCount }}</span>문제 중
            <ml-input class="ml-2 mr-1" style="width: 50px;" type="number" v-model="form.passCount" :min-value="0" :max-value="form.randomQuestionCount"/>
            <span>문제 이상</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module title="관련 자료" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import TableCustom from "@/components/TableCustom.vue";
import {getVideoCodeText, TRAINING_VIDEO_CODE_LIST} from "@/util/TrainingVideo";

export default {
  components: {
    TableCustom,
    FileUploadModule,
    quillEditor,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        value.watchedSecondsForPass = Math.floor(value.duration * (value.validWatchProgress / 100));
        this.$emit("input", value);
      },
    },
    'form.videoId': {
      immediate: true,
      handler(videoId) {
        if (videoId) {
          this.loadYoutube(videoId);
        }
      },
    },
    watchedSecondsForPass(value) {
      this.form.watchedSecondsForPass = value;
    }
  },
  data() {
    return {
      TRAINING_VIDEO_CODE_LIST,
      form: {
        교육대상: "",
        제목: "",
        개요: "",
        videoCode: "", // 영상 종류 (기본교육, 작업자 안전교육, 밀폐공간 안전교육)
        youtubeUrl: "",
        videoId: '',
        duration : 0, // 영상길이
        watchedSecondsForPass: 0, // 수강완료 가능한 시청
        validWatchProgress: 100, // 인정되는 시청 진행률
        passCount: 0, // 합격 개수
        randomQuestionCount: 0, // 랜덤으로 출제되는 문제 수
        questions: [],
        fileList:[],
      },
      player: null,
      timer: null,
    };
  },
  computed: {
    isMobile() {
      return this.$viewport.isMobile;
    }
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    getVideoCodeText,
    // 유튜브 영상 ID 추출 (공통 로직)
    extractYoutubeVideoId(url) {
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    },

    // YouTube API 로드 (최초 1회만)
    loadYoutubeApi() {
      return new Promise((resolve) => {
        if (window.YT && window.YT.Player) {
          resolve();
        } else {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          window.onYouTubeIframeAPIReady = () => {
            resolve();
          };
        }
      });
    },

    async loadYoutube(videoId) {
      const id = videoId || this.extractYoutubeVideoId(this.form.youtubeUrl);
      if (!id || typeof id !== 'string' || id.length !== 11) {
        alert('유효한 YouTube URL을 입력하세요.');
        return;
      }
      this.form.videoId = id;
      await this.loadYoutubeApi();
      if (this.player) {
        // 기존 플레이어가 있다면 비디오를 새로 로드 (자동재생을 하려면 loadVideoById 메서드로 재생해야 함)
        if (this.player.cueVideoById) {//
          this.player.cueVideoById(id);
        }
      } else {
        this.player = new YT.Player('player', {
          width: '100%',
          videoId: id,
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange
          }
        });
      }
    },

    pauseYoutubeVideo() {
      if (this.player && typeof this.player.pauseVideo === 'function') {
        this.player.pauseVideo();
      }
    },

    onPlayerReady(event) {
      const duration = this.player.getDuration(); // 초 단위
      this.form.duration = duration;
    },

    onPlayerStateChange(event) {
      const YTState = window.YT.PlayerState;
      if (event.data === YTState.PLAYING) {
        // 1초마다 시청 시간 체크 시작
        if (!this.timer) {
          this.timer = setInterval(this.trackTime, 1000);
        }
      } else if (event.data === YTState.PAUSED || event.data === YTState.ENDED) {
        // 재생 멈추면 타이머 중지
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    trackTime() {
      if (!this.player || typeof this.player.getCurrentTime !== 'function') return;
      const current = Math.floor(this.player.getCurrentTime());
      if (current > this.lastReportedTime) {
        this.watchedSeconds += current - this.lastReportedTime;
        this.lastReportedTime = current;
        // 여기서 서버로 누적 시간 저장도 가능
        // ex) axios.post('/api/progress', { videoId, time: this.watchedSeconds })
      }
    },

    formatDuration(seconds, format = 'mm:ss') {
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60).toString().padStart(2, '0');

      // format에 따라 반환 (ex: 'mm:ss', 'mm분 ss초')
      return format.replaceAll('mm', m.toString().padStart(2, '0')).replace('ss', s);
    },
    addQuestionsOptions (index) {
      const trData = this.form.questions[index];
      if (!trData.options) {
        trData.options = [];
      }

      trData.options.push({
        answer: false,
        label: '',
        value: '',
      });
      this.$set(this.form.questions, index, trData);
    },
    onInputOptionsValue(rowIndex, index, key, value) {
      const trData = this.form.questions[rowIndex];
      if (!trData.options) {
        trData.options = [];
      }
      if (trData.options[index]) {
        trData.options[index][key] = value;
      } else {
        trData.options.push({
          answer: false,
          label: '',
          value: '',
        });
      }
      this.$set(this.form.questions, rowIndex, trData);
    },
    deleteOptions(rowIndex, index) {
      const trData = this.form.questions[rowIndex];
      if (trData.options && trData.options[index]) {
        trData.options.splice(index, 1);
        this.$set(this.form.questions, rowIndex, trData);
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.border {
  background-color: #fff;
  border: 1px solid #cdcdcd;
}
</style>
